import React from 'react';
import { motion } from 'framer-motion';

export const Card = ({ children, className = '', hover = true, ...props }) => {
  return (
    <motion.div
      whileHover={hover ? { y: -4 } : {}}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className={`bg-white rounded-2xl border border-zinc-100 premium-shadow overflow-hidden ${className}`}
      {...props}
    >
      {children}
    </motion.div>
  );
};